/* eslint-disable complexity */
const sanitize = require('lib/html/sanitize_bio')
const getSpotlight = require('module/user/helpers/get_spotlight')
const getActiveImage = require('module/user/helpers/get_active_image')
const hasSignature = require('module/user/helpers/has_signature')
const log = require('log').create('hasFeature') // eslint-disable-line

function hasFeatureHelper(user, feature) {
    switch (feature) {
        case 'spotlight': {
            return getSpotlight(user)
        }

        case 'pro_spotlights': {
            const spotlight = getSpotlight(user)
            return spotlight && spotlight.is_premium
        }

        case 'upgrade': {
            return user.flags && user.flags.premium
        }

        case 'domain': {
            return user.mapped_domains && user.mapped_domains.length > 0
        }

        case 'bio': {
            return sanitize(user.bio).length
        }

        case 'email_signature': {
            return !!hasSignature(user)
        }

        case 'image': {
            return !!getActiveImage(user)
        }

        case 'social_links': {
            return user.apps && user.apps.length
        }

        case 'portfolio': {
            return user.portfolio && user.portfolio.length > 0
        }

        case 'testimonials': {
            return user.testimonials && user.testimonials.items && user.testimonials.items.length
        }

        case 'video': {
            return user.video && user.video.type
        }

        case 'contact_me': {
            return user.contact_me && user.contact_me.enabled
        }

        case 'standard': {
            if (!user.store) return false

            if (!Array.isArray(user.store.purchases)) return false

            return user.store.purchases.some((p) => p.id === 'standard' && p.status === 'active')
        }

        default:
            if (__DEBUG__) throw new Error(`There is no test for this feature: ${feature}`)
            return false
    }
}

module.exports = function hasFeature(user, feature) {
    // coerce boolean from result
    return !!hasFeatureHelper(user, feature)
}
